module.exports = __webpack_public_path__ + "static/media/achieved-light-green.ba54e07b.svg";